import { render, staticRenderFns } from "./primeoMulti.vue?vue&type=template&id=275a9846&"
import script from "./primeoMulti.vue?vue&type=script&lang=js&"
export * from "./primeoMulti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports